import { SupportedLocales, isValidLocale } from "./localization";

export function getCurrentRoute(): { route: string; locale: SupportedLocales } {
    if (typeof window == "undefined") {
        throw new Error("getCurrentRoute can only be called in the browser");
    }

    // Logic copied from parseRoute in wac-routes.ts
    const noSlashPrefixPath = window.location.pathname.replace(/^\/+/, "");
    const potentialLocale = noSlashPrefixPath.split("/")[0] || "";
    const localeIsValid = isValidLocale(potentialLocale);
    const locale = localeIsValid ? potentialLocale : "en";

    return { route: window.location.pathname, locale };
}
